<table>
  <!-- Read more about KeyValuePipe: https://angular.io/api/common/KeyValuePipe -->
  @for (field of formSection[1] | keyvalue: indexOrderAsc; track field; let fieldIdx = $index) {
    <tr
      class="data-value-container"
      >
      @if (!(field?.value?.DataTypeName === 'BIT') && !field?.value?.isHidden) {
        <section
          #docFieldTitle
          id="{{ field.key }}"
          class="data-value-container"
          >
          <td class="data-key">
            {{ getValue(field.value, 'DataFieldName') }}
            @if (fieldValues[docFieldTitle.id]?.requirement === '') {
              <span
                class="required"
                data-toggle="tooltip"
                data-placement="auto"
                title="Required"
                >
                *
              </span>
            }
          </td>
          @if (!(field?.value?.DataTypeName === 'BIT')) {
            <td
              class="data-value"
        [ngClass]="{
          'data-value-container-label': field?.value?.DataTypeName === 'N/A',
        }"
              >
              <!-- Main input for each field with string value to control it -->
              <form #docFieldValue name="{{ field.key }}">
                <!-- use readonly instead of disabled as it prevents viewportScroller from working -->
                <!-- (ngModelChange)="fieldValues[docFieldValue.name].DataValue = $event"
                (keyup)="onInputKeyUp($event)"  -->
                @if (field?.value?.DataTypeName === 'STRING' || !field?.value?.DataTypeName) {
                  <input
                    name="{{ field.key }}"
                    type="text"
                    [(ngModel)]="fieldValues[docFieldValue.name].DataValue"
                    (change)="onInputChange($event)"
                    (click)="onInputClick($event)"
            [ngClass]="{
              changedValue:
                changedFieldKeys.indexOf(field.key) > -1 &&
                !fieldValues[docFieldValue.name]?.invalid,
              invalidInput: fieldValues[docFieldValue.name]?.invalid,
              inputIdHighlightActive: 'Right-' + inputIdHighlightActive === field.value.AnchorID,
              'input-readonly': disableEditing,
            }"
                    id="{{ field.value.AnchorID }}"
                    [readonly]="disableEditing"
                    />
                }
              </form>
              <div class="error-messages">
                @if (
                  fieldValues[docFieldTitle.id]?.requirement === 'required' &&
                  !fieldValues[docFieldValue.name]?.DataValue?.length
                  ) {
                  <div
                    >
                    Valid {{ docFieldValue.name }} is required.
                  </div>
                }
                <!-- Below is the invalid field message in case we go back to validating -->
          <!-- <div *ngIf="
            fieldValues[docFieldValue.name]?.invalid &&
            fieldValues[docFieldValue.name]?.DataValue?.length
          ">
                {{ invalidMessage(docFieldValue.name) }}
              </div> -->
              <!-- <div *ngIf="checkInterdependencies(field, formSection[1])">
              <div *ngFor="let dependency of accessFailedDependencies(field, formSection[1])">
                Valid {{ dependency }} is required.
              </div>
            </div> -->
          </div>
        </td>
      }
    </section>
  }
  <!-- Main input for field if the value is boolean (checkbox) -->
  @if (field?.value?.DataTypeName === 'BIT' && !field?.value?.isHidden) {
    <section
      class="data-value-container-checkbox"
      >
      <td>
        <form #docFieldValue name="{{ field.key }}">
          <!--
          checkbox can't be disabled as it ignores the clicks (and highlighting) -
          handle disabled in the logic instead
          -->
          <!-- (ngModelChange)="fieldValues[docFieldValue.name].DataValue = $event"
          (change)="onCheckboxChange($event)" -->
          <input
            name="{{ field.key }}"
            type="checkbox"
            [(ngModel)]="fieldValues[docFieldValue.name].DataValue"
            (change)="onInputChange($event)"
            (click)="onCheckboxClick($event); onInputClick($event)"
            class="checkbox"
            [ngClass]="{
              inputIdHighlightActive: 'Right-' + inputIdHighlightActive === field.value.AnchorID,
              'checkbox-readonly': disableEditing,
            }"
            id="{{ field.value.AnchorID }}"
            />
          </form>
        </td>
        <td #docCheckboxTitle id="{{ field.key }}" class="data-key">
          {{ getValue(field.value, 'DataFieldName') }}
          @if (fieldValues[docCheckboxTitle.id]?.requirement === 'required') {
            <span
              class="required"
              data-toggle="tooltip"
              data-placement="auto"
              title="Required"
              >
              *
            </span>
          }
        </td>
      </section>
    }
    <!-- Main input for field if the value is DATE (datepicker) -->
    @if (field?.value?.DataTypeName === 'DATE' && !field?.value?.isHidden) {
      <section>
        <td>
          <form #docFieldValue name="{{ field.key }}">
            <input
              type="date"
              id="{{ field.value.AnchorID }}"
              name="{{ field.key }}"
              class="datepicker"
              onkeydown="return false"
              [readonly]="disableEditing"
              [disabled]="disableEditing"
              [max]="today"
              min="1900-01-01"
              (click)="onInputClick($event)"
              [ngModel]="fieldValues[docFieldValue.name].DataValue | date: 'yyyy-MM-dd'"
              (ngModelChange)="fieldValues[docFieldValue.name].DataValue = $event"
              (change)="onInputChange($event)"
            [ngClass]="{
              inputIdHighlightActive: 'Right-' + inputIdHighlightActive === field.value.AnchorID,
              'checkbox-readonly': disableEditing,
            }"
              />
            </form>
          </td>
        </section>
      }
      <!--
      Show divider between rows when input fields form a grid
      TODO: Move to its own component
      -->
      @if (
        fieldIdx > 0 &&
        field.value.RowNumber <= gridRowsCount &&
        formSection[0].isGrid &&
        !field.value.isHidden &&
        fieldIdx % gridColumnsCount === 0
        ) {
        <section
          class="grid-row-divider"
          >
          <hr />
          @if (
            field.value.RowNumber === lastVisibleRowNumber && field.value.RowNumber < gridRowsCount
            ) {
            <button
              class="add-row-button"
              (click)="showNextGridRow(field.value)"
              data-toggle="tooltip"
              data-placement="auto"
              title="Add row to the table"
              >
              +
            </button>
          }
          <hr />
        </section>
      }
    </tr>
  }
</table>
